<template>
  <v-app id="registration-page">
      <cookie-law theme="blood-orange--rounded" 
                  buttonText="ACCETTO!">
                  <div slot="message">
                    QuickBe Utilizza cookie tecnici e di terze parti per fornirti il migliore servizio possible, 
                    puoi vedere in dettaglio cosa usiamo e come disabilitarlo da qui:
                    <router-link class="q-orange"
                      :title="getString('Uso dei cookies')"
                      to="/legal/cookie">Info Cookie
                    </router-link>
            </div>
      </cookie-law>
    <v-content style="margin-bottom:150px">
      <header-p></header-p>
      <section id="registerForm" style="margin-top:30px">
        <v-layout style="padding-left:20px;padding-right:20px" v-if="!sended">
          <v-flex xs12 sm10 offset-sm1 md10 offset-md-1 offset-lg3 lg6>
            <v-card class="elevation-0">
              <v-toolbar class="q-orange-bk white--text">
                <div style="width:100%; justify-content: center; display:flex">
                  <h2 style="font-size:30px;font-weight:lighter;">{{getString('Affiliazione')}}</h2>
                </div>
              </v-toolbar>
              <v-card-title primary-title>
                <div style="margin-left:10px">
                  <h3
                    class="headline mb-0"
                    v-html="getString(`Inviaci i tuoi dati per entrar subito a far parte del programma di affiliazione. Puoi trovare tutte le regole <a class='a' href='/legal/affil'>qui.</a>`)"
                  ></h3>
                  <div style="margin-bottom:30px">
                    <b>{{getString(`N.B.`)}}</b>
                    {{getString(' alcuni campi sono obbligatori*')}}
                  </div>
                  <v-layout row wrap>
                    <v-flex xs12 md12 lg6 sm12 style="padding-right:20px;">
                      <v-text-field
                        color="#212121"
                        v-bind:disabled="sended"
                        solo
                        v-model="name"
                        :rules="nameRules"
                        v-bind:label="getString('Nome e cognome*')"
                        v-bind:hint="getString('Il tuo nome e cognome, esempio: Mariarco Lucreziano')"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md12 lg6 sm12 style="padding-left:20px;">
                      <v-text-field
                        color="#212121"
                        v-bind:disabled="sended"
                        solo
                        v-model="email"
                        :rules="emailRules"
                        v-bind:label="getString('Email*')"
                        v-bind:hint="getString('La tua email, esempio: dthecarriage@outlook.com')"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn
                        style="margin-left:-2px"
                        @click="sendStuff"
                        class="q-orange-bk q-text-whitesmoke"
                        :disabled="!valid"
                      >{{getString('Ottieni il codice')}}</v-btn>
                    </v-flex>
                    <v-flex xs12>
                      <div style="margin-left:25px" id="g-recaptcha1"></div>
                    </v-flex>
                  </v-layout>
                  <v-layout column>
                    <v-flex xs12 sm4 class="my-3">
                      <div class="text-xs-center">
                        <v-container>
                          <v-btn
                            class="q-orange"
                            @click="$router.push({path:'/'})"
                          >{{getString('Torna a QuickBe')}}</v-btn>
                        </v-container>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-title>

              <v-card-actions>
                <!-- <v-container>
                                <v-btn v-if="!sended" @click='sendForm()' class="q-orange">{{getString('Invia')}}</v-btn>
                </v-container>-->
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout column v-if="sended">
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center">
              <h2 class="q-headline">{{getString('Grazie per aver scelto QuickBe!')}}</h2>
              <span
                class="subheading"
              >{{getString(`Verrai contattato al più presto da un nostro incaricato per il resto.`)}}</span>
              <v-container>
                <v-btn
                  class="q-orange"
                  @click="$router.push({path:'/'})"
                >{{getString('Torna a QuickBe')}}</v-btn>
              </v-container>
            </div>
          </v-flex>
        </v-layout>
      </section>
    </v-content>
    <v-footer dark height="auto" class=".footer">
      <v-card class="flex" flat tile>
        <v-card-title class="q-orange-bk">
          <strong class="subheading">{{getString("Seguici sui social!")}}</strong>
          <v-spacer></v-spacer>
          <v-btn
            v-for="icon in icons"
            :key="icon.ic"
            class="mx-3"
            dark
            icon
            @click="navigate(icon.url)"
          >
            <v-icon size="24px">{{ icon.ic }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="grey darken-3 justify-center" style="text-align:center">
          &copy; 2018 - &copy;{{(new Date()).getFullYear()}} — &nbsp;
          <strong>Dew Studio </strong> &nbsp; — &nbsp;
          <a href="https://plaza.quickbe.app">{{getString('QuickBe Plaza')}}</a>&nbsp; — &nbsp;
          <router-link to="/legal/tec">{{getString('Trattamento dati')}}</router-link>&nbsp; — &nbsp;
          <router-link to="/legal/cookie">{{('Cookie Policy')}}</router-link>&nbsp; — &nbsp;
          <router-link to="/legal/eula">{{('Termini e condizioni')}}</router-link>&nbsp; — &nbsp;
          <router-link to="/admin/login">{{getString('Portale')}}</router-link>
        </v-card-text>
      </v-card>
    </v-footer>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card class="q-whitesmoke-bk black--text" dark>
        <v-card-text>
          {{getString('Invio in corso')}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" hide-overlay persistent width="300">
      <v-card class="green lighten-3" dark>
        <v-card-text>
          <h4>{{getString('Inviato con successo, controlla la tua email')}}</h4>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogError" hide-overlay persistent width="300">
      <v-card class="red lighten-1" dark>
        <v-card-text>
          <h4>{{getString('Errore nell\'invio, riprova più tardi')}}</h4>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogErrorMissing" hide-overlay persistent width="300">
      <v-card class="red lighten-1" dark>
        <v-card-text>
          <h4>{{getString('Campi mancanti')}}</h4>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import ajax from "../../ajax";
import Utils from "../../utils";
import HeaderP from "./Header";
import CookieLaw from "vue-cookie-law";
let ut = new Utils();
export default {
  name: "RegisterFidel",
  destroyed: function(){
      if(this.captchaHandler1 !== null)
        clearInterval(this.captchaHandler1);
  },
  mounted: function() {
    // self.captchaHandler1 = setInterval(function() {
    //   if (window.grecaptcha) {
    //     if (typeof window.grecaptcha !== "function") {
    //       this.rcapt_id1 = grecaptcha.render(
    //         document.getElementById("g-recaptcha1"),
    //         {
    //           sitekey: self.rcapt_sig_key1,
    //           callback: self.reCallback1
    //         }
    //       );
    //       clearInterval(self.captchaHandler1);
    //     }
    //   }
    // }, 200);
  },
  components: {
    HeaderP,
    CookieLaw
  },
  computed: {
    pivaRules: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v => /[0-9]+/.test(v) || this.getString("P. Iva non valida")
      ];
    },
    cScontRule: function() {
      return [
        v =>
          /^[A-Z]{3}-[0-9]{4, 8}$|^$/g.test(v) ||
          this.getString('Codice sconto non valido. Usa il formato: "AAA-0000"')
      ];
    },
    cfRules: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v => ut.ValidateCF(v) || this.getString("Codice fiscale non valido")
      ];
    },
    capRules: function() {
      return [v => !!v || this.getString("Campo richiesto")];
    },
    nameRules: function() {
      return [v => !!v || this.getString("Campo richiesto")];
    },
    emailRules: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v => ut.ValidateEmail(v) || this.getString("Email non valida")
      ];
    },
    knowledge: function() {
      return [
        {
          text: this.getString("Passaparola"),
          value: "w"
        },
        {
          text: this.getString("Motore di ricerca"),
          value: "se"
        },
        {
          text: this.getString("Facebook"),
          value: "fb"
        },
        {
          text: this.getString("Instagram"),
          value: "in"
        },
        {
          text: this.getString("Altro"),
          value: "ot"
        }
      ];
    },
    validStep1: function() {
      return (
        this.shop !== "" &&
        this.shopAddress !== "" &&
        this.cap !== "" &&
        this.shopCity !== "" &&
        this.prov !== ""
      );
    },
    validStep2: function() {
      return (
        /.+@.+/.test(this.email) && this.name !== "" && this.surname !== ""
      );
    },
    valid: function() {
      return ut.ValidateEmail(this.email) && this.name !== "";
    }
  },
  watch: {
    cf: function(n, o) {
      this.cf = this.cf.toUpperCase();
    }
  },
  data: () => {
    return {
      captchaHandler1: null,
      rcapt_sig_key1: "6LfDvHkUAAAAAMb8pSDfibOvAzznCbTlVlw0qEnf",
      rcapt_id1: 0, // will be used later
      rcapt_resp1: false,
      e1: 0,
      presCode: "",
      dialog: false,
      sended: false,
      dialogError: false,
      dialogSuccess: false,
      dialogErrorMissing: false,
      icons: [
        {
          ic: "fab fa-facebook",
          url: "https://www.facebook.com/QuickBeApp/"
        },
        {
          ic: "fab fa-instagram",
          url: "https://www.instagram.com/quickbeapp/"
        }
      ],
      name: "",
      surname: "",
      email: "",
      phone: "",
      shop: "",
      shopAddress: "",
      shopCity: "",
      cap: "",
      prov: "",
      rsocial: "",
      fatAddress: "",
      cf: "",
      piva: "",
      message: "",
      select: null,
      accept: ""
    };
  },
  methods: {
    captchaCallback: function(response) {},
    navigate: function(url) {
      window.open(url);
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    sendStuff: function() {
      let self = this;
      if (this.valid) {
        this.dialog = true;
        ajax.axios
          .post(
            ajax.baseUrl() + "/requestcoupon",
            // params
            {
              name: this.name,
              email: this.email
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.dialog = false;
            self.dialogSuccess = true;
            self.sended = true;
            setTimeout(function() {
              self.dialogSuccess = false;
            }, 4000);
          })
          .catch(function(error) {
            self.dialog = false;
            self.dialogError = true;
            setTimeout(function() {
              self.dialogError = false;
            }, 4000);
          });
      } else {
        self.dialog = false;
        self.dialogErrorMissing = true;
        setTimeout(function() {
          self.dialogErrorMissing = false;
        }, 2000);
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/frontend/RegisterFidel.vue